import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/files`;

export default {
  getFilesByFolderType(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${resource}/pagedlist/byfoldertype`, {
      baseURL,
      headers,
      params,
      paramsSerializer
    });
  },

  sendFile(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/byfoldertype`, body ,{
      baseURL,
      headers,
      params,

    });
  },
  sendFileBySupplierAccess(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/byfoldertype/bysupplier`, body ,{
      baseURL,
      headers,
      params,

    });
  },
  sendFileWithoutFolderType(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body ,{
      baseURL,
      headers,
      params,

    });
  },

  //--------------- file management------------ //
  // getFilesByFolderType(baseURL = {}, headers = {}, params = {}) {
  //   return BaseRepository.get(`${resource}/pagedlist/byfoldertype`, {
  //     baseURL,
  //     headers,
  //     params,
  //   });
  // },
  // sendFileByFolderType(body, baseURL = {}, headers = {}, params = {}) {
  //   return BaseRepository.post(`${resource}/byfoldertype`, body, {
  //     baseURL,
  //     headers,
  //     params,
  //   });
  // },
  // sendFile(body, baseURL = {}, headers = {}, params = {}) {
  //   return BaseRepository.post(`${resource}`, body, {
  //     baseURL,
  //     headers,
  //     params,
  //   });
  // },
};


